import { render, staticRenderFns } from "./MultiselectAvatarNew.vue?vue&type=template&id=ae6509ca&scoped=true"
import script from "./MultiselectAvatarNew.vue?vue&type=script&lang=ts"
export * from "./MultiselectAvatarNew.vue?vue&type=script&lang=ts"
import style0 from "./MultiselectAvatarNew.vue?vue&type=style&index=0&id=ae6509ca&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae6509ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae6509ca')) {
      api.createRecord('ae6509ca', component.options)
    } else {
      api.reload('ae6509ca', component.options)
    }
    module.hot.accept("./MultiselectAvatarNew.vue?vue&type=template&id=ae6509ca&scoped=true", function () {
      api.rerender('ae6509ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/MultiselectAvatarNew.vue"
export default component.exports